<template>
    <div
        :class="{
            'dk-popper-item': true,
            'dk-popper-item--selectable': isSelectable,
            'dk-popper-item--selected': selected && isParentDkPopper,
        }"
    >
        <a :href="href" class="dk-popper-item__link" @click="handleClick">
            <slot></slot>
        </a>
    </div>
</template>

<script>
import { hasClass, removeClass, addClass } from '@v4/common/utils/dom';

export default {
    name: 'DkPopperItem',
    props: {
        /**
         * Anchor tag
         */
        href: {
            type: String,
            default: '#',
        },
        /**
         * Whether or not the item is selected
         */
        selected: {
            type: Boolean,
            default: false,
        },
        /**
         * Data item to pass through
         */
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        isParentDkPopper() {
            return !!(this.$parent && this.$parent.$options.name === 'DkPopper');
        },
        isSelectable() {
            return !!(this.isParentDkPopper && this.$parent.selectable);
        },
        hasHideTooltipMethod() {
            return this.$parent.hideTooltip && typeof this.$parent.hideTooltip === 'function';
        },
    },
    mounted() {
        if (this.isSelectable) {
            if (this.$parent.multiple) {
                const selectedTexts = this.$parent.$children
                    .filter((child) => hasClass(child.$el, 'dk-popper-item--selected'))
                    .map((item) => item.$el.innerText);

                if (!selectedTexts.length) {
                    selectedTexts.push(this.$parent.buttonText);
                }

                this.updateButtonText(selectedTexts);
            } else {
                if (this.selected) {
                    this.updateButtonText([this.$el.innerText]);
                }
            }
        }
    },
    methods: {
        handleClick(e) {
            if (this.href && this.href !== '#') {
                return this.$parent.hideTooltip();
            }

            if (this.$parent && this.$parent.$options.name === 'DkPopper') {
                e.preventDefault();

                if (this.$parent.selectable) {
                    const activeClassName = 'dk-popper-item--selected';
                    const dkPopperItemsInstances = this.$parent.$children.filter((child) =>
                        hasClass(child.$el, 'dk-popper-item')
                    );

                    if (this.$parent.multiple) {
                        if (hasClass(this.$el, activeClassName)) {
                            removeClass(this.$el, activeClassName);
                        } else {
                            addClass(this.$el, activeClassName);
                        }

                        const selectedItems = this.$parent.$children.filter((item) =>
                            hasClass(item.$el, activeClassName)
                        );

                        const selectedTexts = selectedItems.map((item) => item.$el.innerText);

                        if (!selectedItems.length) {
                            selectedTexts.push(this.$parent.buttonText);
                        }

                        this.updateButtonText(selectedTexts);
                        this.$parent.$emit(
                            'change',
                            selectedItems.map((item) => ({
                                item: item.item,
                                element: item.$el,
                                e,
                            }))
                        );
                    } else {
                        const wasAlreadySelected = hasClass(this.$el, activeClassName);

                        for (const dkPopperItem of dkPopperItemsInstances) {
                            if (!hasClass(dkPopperItem.$el, activeClassName)) {
                                continue;
                            }

                            removeClass(dkPopperItem.$el, activeClassName);
                        }

                        addClass(this.$el, activeClassName);

                        const eventDetail = { item: this.item, element: this.$el, e };

                        if (wasAlreadySelected) {
                            this.$parent.$emit('re-clicked', eventDetail);
                        } else {
                            this.updateButtonText([this.$el.innerText]);
                            this.$parent.$emit('change', eventDetail);
                        }

                        if (this.hasHideTooltipMethod) {
                            this.$parent.hideTooltip();
                        }
                    }
                } else {
                    if (this.hasHideTooltipMethod) {
                        this.$parent.hideTooltip();
                    }
                }
            }
        },
        updateButtonText(texts = []) {
            this.$parent.btnText = texts.join(', ');
        },
    },
};
</script>
